<template>
  <div class="page record">
    <div class="top">
      <div>
        <div class="icon"><i class="fa-regular fa-star"></i></div>
        <div class="title"><span>Recordes</span></div>
      </div>
      <div class="actions">
        <div>
          <i class="fa-solid fa-magnifying-glass"></i>
          <input type="text" name="search" v-model="search" @change="getItens()" placeholder="Pesquisar...">
        </div>
        <button :disabled="disableP" @click="getItens(prev)"><i class="fa-solid fa-angle-left"></i>
        </button>
        <button :disabled="disableN" @click="getItens(next)"><i class="fa-solid fa-angle-right"></i>
        </button>
      </div>
    </div>
    <div class="content">
      <template v-if="loading">
        <div class="box" v-for="i in 15" :key="i">
          <div class="box-in">
            <Sk w="100%" h="100px" rounded="rounded-lg" />
          </div>
          <Sk w="70%" h="12px" extra="mt-1 mx-auto" />
        </div>
      </template>
      <div class="box" v-else v-for="(r, index) in record" :key="index" @click="setMod(r.id)">
        <div class="box-in">
          <div class="img" :style="{backgroundImage: 'url('+r.imagem+')'}">
            <div class="icon"
               :style="{backgroundImage: r.code
                 ? 'url(https://images.habblet.city/library/hof_furni/icons/'+r.code+'_icon.png)'
                 : 'url('+r.imagem_mob+')'}"></div>
          </div>
          <div class="itens">
            <div class="icon"></div>
            <span><strong>{{ r.itens }}</strong> itens</span>
          </div>
        </div>
        <div class="name">{{ r.name }}</div>
      </div>
    </div>
    <Transition name="slide-fade">
      <ModRecord v-if="showMod" :id="rec_id" @close="showMod = false" />
    </Transition>
  </div>
</template>

<script setup>

import { getRecords } from '@/services/api.js'
import ModRecord from '@/components/modals/record.vue'
import Sk from '@/components/usefulness/Sk.vue'
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const record = ref([])
const loading = ref(true)
const prev = ref(0)
const next = ref(0)
const disableN = ref(false)
const disableP = ref(false)
const search = ref(route.query?.s ?? '')
const rec_id = ref(0)
const showMod = ref(false)

async function getItens(pag = 1) {
  loading.value = true
  const data = await getRecords({ pag, s: search.value })
  record.value  = data.record
  prev.value    = data.prev
  next.value    = data.next
  disableP.value = parseInt(data.prev) === 0
  disableN.value = data.next === 0
  loading.value = false
}

function setMod(id) {
  rec_id.value = id
  showMod.value = true
}

getItens()

watch(() => route.query?.s, (newRoute) => {
  search.value = newRoute
  getItens(1)
})

</script>

<style scoped>
.record .top {
  display: flex;
  justify-content: space-between;
}

.record .top .icon {
  background-color: #0D93C6;
  background-image: none;
}


.record .top .actions {
  width: 34%;
  display: flex;
  justify-content: space-between;
}

.record .top .actions div > i {
  position: absolute;
  margin: 12px 0 0 14px;
  font-size: 13px;
}

.record .top .actions div > input {
  float: left;
  width: 170px;
  height: 36px;
  background-color: #fff;
  border-radius: 20px;
  padding-left: 36px;
}

.record .top .actions button {
  float: left;
  width: 36px;
  height: 36px;
  border-radius: 30px;
  background-color: #D7DDE4;
  font-size: 14px;
  text-align: center;
  line-height: 36px;
  color: #BDC4CD;
}

.record .content {
  box-shadow: none;
  background-color: transparent;
  display: flex;
  flex-flow: wrap;
  justify-content: space-around;
}

.record .content .box {
  position: relative;
  width: calc(33% - 8px);
  height: 190px;
  background-color: #fff;
  border-radius: 12px;
  margin-top: 8px;
}

@media only screen and (max-width: 600px) {
  .record .content .box {
    width: calc(50% - 8px);
  }
  .record .content .box .name {
    font-size: 11px;
    line-height: 1.2;
    height: auto;
    padding: 4px 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.record .content .box .box-in {
  position: relative;
  float: left;
  width: 100%;
  height: 140px;
  background: rgb(255, 255, 255);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(13, 147, 198, .4) 100%);
  border-radius: 12px 12px 0 0;
  z-index: 0;
}

.record .content .box-in .img {
  position: relative;
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: cover;
  border-radius: 12px 12px 0 0;
}

.record .content .box-in .itens {
  position: absolute;
  top: 0;
  left: 0;
  width: auto;
  height: 32px;
  background-color: #0D93C6;
  border-radius: 12px 0 12px 0;
  text-align: center;
  line-height: 32px;
  color: #fff;
  font-size: 14px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  z-index: 9;
}

.record .content .box-in .itens .icon {
  position: relative;
  width: 11px;
  height: 14px;
  background-image: url('../assets/medal.png');
  background-repeat: no-repeat;
  top: 9px;
  right: 6px;
}

.record .content .box-in .img .icon {
  position: absolute;
  margin: 20% 0 0 40%;
  width: 55px;
  height: 55px;
  background-color: rgba(0, 0, 0, .8);
  border-radius: 8px;
  background-position: center;
  background-repeat: no-repeat;
}

.record .content .box .name {
  width: 100%;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-size: 14px;
  font-weight: 600;
}
</style>
